export default __webpack_public_path__ + "static/media/delete.4fbb9a3d.svg";